(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('InvoicePriceDetailController', InvoicePriceDetailController);

    InvoicePriceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'InvoicePrice', 'Invoice', 'Fixation', 'Lot'];

    function InvoicePriceDetailController($scope, $rootScope, $stateParams, previousState, entity, InvoicePrice, Invoice, Fixation, Lot) {
        var vm = this;

        vm.invoicePrice = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('ccsTrApp:invoicePriceUpdate', function(event, result) {
            vm.invoicePrice = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
